/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/fetchClient.js";
import type { ResearchChatControllerGetMessageQueryResponse, ResearchChatControllerGetMessagePathParams, ResearchChatControllerGetMessage400, ResearchChatControllerGetMessage401, ResearchChatControllerGetMessage403, ResearchChatControllerGetMessage404, ResearchChatControllerGetMessage409, ResearchChatControllerGetMessage500 } from "../types/ResearchChatControllerGetMessage.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/fetchClient.js";

function getResearchChatControllerGetMessageUrl(messageId: ResearchChatControllerGetMessagePathParams["messageId"]) {
  const res = { method: 'GET', url: `/api/research-chat/message/${messageId}` as const }
  return res
}

/**
 * @description Retrieves the complete message including AI response and web citations. Only available after status is FINISHED.
 * @summary Get full message with content and citations
 * {@link /api/research-chat/message/:messageId}
 */
export async function researchChatControllerGetMessage(messageId: ResearchChatControllerGetMessagePathParams["messageId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ResearchChatControllerGetMessageQueryResponse, ResponseErrorConfig<ResearchChatControllerGetMessage400 | ResearchChatControllerGetMessage401 | ResearchChatControllerGetMessage403 | ResearchChatControllerGetMessage404 | ResearchChatControllerGetMessage409 | ResearchChatControllerGetMessage500>, unknown>({ method : "GET", url : getResearchChatControllerGetMessageUrl(messageId).url.toString(), ... requestConfig })
  return res.data
}